import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CandidateFormActionsUnion, CandidateFormActionTypes } from './candidate-form.actions';

export interface CandidateFormState {
  candidateFormId: number;
}

export const initialState: CandidateFormState = {
  candidateFormId: 0,
};

export function candidateFormReducer(state = initialState, action: CandidateFormActionsUnion): CandidateFormState {
  if (action.type === CandidateFormActionTypes.SelectCandidateFormId) {
    return { candidateFormId: action.payload };
  } else {
    return state;
  }
}

export const getCandidateFormState = createFeatureSelector<CandidateFormState>('candidateForm');

export const getCandidateFormId = createSelector(getCandidateFormState, (state: CandidateFormState) => state.candidateFormId);
